export default "__VITE_ASSET__BF$ifT25__"